import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { RootState } from '../../../store'

type SidebarState = {
  isOpen: boolean
}

const initialState: SidebarState = {
  isOpen: true, // Default to open on desktop
}

export const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    setSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload
    },
    toggleSidebar: (state) => {
      state.isOpen = !state.isOpen
    },
    closeSidebar: (state) => {
      state.isOpen = false
    },
    openSidebar: (state) => {
      state.isOpen = true
    },
  },
})

export const selectSidebarIsOpen = (state: RootState) => state.sidebar.isOpen

export const { setSidebarOpen, toggleSidebar, closeSidebar, openSidebar } = sidebarSlice.actions

export default sidebarSlice.reducer
